(function () {
  let addonRequestInFlight = false;
  const addonDismissedKeys = new Set();
  const TOO_MANY_REQUESTS_MESSAGE = 'Too many actions. Please refresh to confirm your items.';

  function setCartDrawerError(message) {
    const errorsNode = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    if (!errorsNode) return;
    errorsNode.textContent = message || '';
  }

  function createResponseError(response, fallbackMessage) {
    const error = new Error(fallbackMessage || 'Request failed');
    error.status = response.status;
    return error;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const moneyFormat =
        window.Shopify.money_format ||
        document.documentElement.getAttribute('data-money-format') ||
        '${{amount}}';
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function findAddonItem(cart, variantId) {
    return (cart.items || []).find(function (item) {
      return Number(item.variant_id) === Number(variantId);
    });
  }

  function cleanupAddonLineItems() {
    const addonNode = document.querySelector('[data-cart-addon]');
    if (!addonNode) return;

    const variantId = Number(addonNode.dataset.variantId || 0);
    if (!variantId) return;

    document.querySelectorAll('#CartDrawer .cart-item').forEach(function (item) {
      const quantityInput = item.querySelector('.quantity__input');
      const removeButton = item.querySelector('.cart-remove-button [data-variant-id]');
      const lineVariantId = Number(
        quantityInput?.dataset.quantityVariantId ||
          removeButton?.dataset.variantId ||
          0
      );

      if (lineVariantId === variantId) {
        item.remove();
      }
    });
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });

    if (!response.ok) throw createResponseError(response, 'Failed to fetch cart');
    return response.json();
  }

  async function addVariant(variantId) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    });

    if (!response.ok) {
      const error = await response.json().catch(function () {
        return {};
      });
      const requestError = new Error(error.description || 'Failed to add add-on');
      requestError.status = response.status;
      throw requestError;
    }

    return response.json();
  }

  async function removeLineItem(key) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
      }),
    });

    if (!response.ok) {
      const error = await response.json().catch(function () {
        return {};
      });
      const requestError = new Error(error.description || 'Failed to remove add-on');
      requestError.status = response.status;
      throw requestError;
    }

    return response.json();
  }

  function getSectionsToRender() {
    const sections = [];

    if (document.getElementById('CartDrawer')) {
      sections.push({
        id: 'cart-drawer-sht',
        target: function () {
          return document.getElementById('CartDrawer');
        },
        selector: '#CartDrawer',
      });
    }

    const bubbleSection = document.getElementById('cart-icon-bubble')?.closest('.shopify-section');
    if (bubbleSection) {
      sections.push({
        id: 'cart-icon-bubble',
        target: function () {
          return document.getElementById('cart-icon-bubble')?.closest('.shopify-section');
        },
        selector: '.shopify-section',
      });
    }

    if (document.getElementById('main-cart-items')) {
      sections.push({
        id: 'cart-items',
        target: function () {
          return document.getElementById('main-cart-items');
        },
        selector: '#main-cart-items',
      });
    }

    if (document.getElementById('main-cart-footer')) {
      sections.push({
        id: 'cart-footer',
        target: function () {
          return document.getElementById('main-cart-footer');
        },
        selector: '#main-cart-footer',
      });
    }

    return sections;
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const node = parsed.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  async function renderSections() {
    const sections = getSectionsToRender();
    if (!sections.length) return;

    const query = sections
      .map(function (section) {
        return section.id;
      })
      .join(',');

    const response = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(query), {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });

    if (!response.ok) throw createResponseError(response, 'Failed to render sections');

    const parsed = await response.json();

    sections.forEach(function (section) {
      const target = section.target();
      if (!target || !parsed[section.id]) return;

      const html = getSectionInnerHTML(parsed[section.id], section.selector);
      if (html == null) return;

      target.innerHTML = html;
    });

    cleanupAddonLineItems();
    document.dispatchEvent(new CustomEvent('cart:addon:updated'));
    initAll();
  }

  function setLoading(node, loading) {
    const toggle = node.querySelector('[data-cart-addon-toggle]');
    if (!toggle) return;

    toggle.disabled = loading;
    node.style.pointerEvents = loading ? 'none' : '';
    node.style.opacity = loading ? '0.72' : '';
    node.classList.toggle('is-loading', loading);
  }

  function syncVisibleSummary(cart) {
    const countNodes = document.querySelectorAll('[data-cart-count-label]');
    countNodes.forEach(function (node) {
      node.textContent = Number(cart.item_count || 0);
    });

    const subtotalNode = document.querySelector(
      '.cart-drawer__summary-stack-row--subtotal strong, .cart-drawer__summary-row--subtotal strong'
    );
    if (subtotalNode) {
      subtotalNode.textContent = formatMoney(cart.total_price || 0);
    }

    const totalSavings = Math.max(0, Number(cart.original_total_price || 0) - Number(cart.total_price || 0));
    const savingsNode = document.querySelector(
      '.cart-drawer__summary-stack-row--savings strong, .cart-drawer__summary-row--savings strong'
    );
    if (savingsNode) {
      savingsNode.textContent = totalSavings > 0 ? `-${formatMoney(totalSavings)}` : formatMoney(0);
    }

    const originalNode = document.querySelector('.cart-drawer__summary-combined-original');
    if (originalNode) {
      originalNode.textContent = formatMoney(cart.original_total_price || cart.total_price || 0);
    }
  }

  function syncAddonNode(node, cart) {
    const toggle = node.querySelector('[data-cart-addon-toggle]');
    const variantId = Number(node.dataset.variantId || 0);
    if (!toggle || !variantId) return;

    const matchedItem = findAddonItem(cart, variantId);
    node.dataset.lineItemKey = matchedItem ? matchedItem.key : '';
    toggle.checked = !!matchedItem;
  }

  async function runCartMutation(node, mutationFn) {
    if (addonRequestInFlight) return;
    addonRequestInFlight = true;
    setLoading(node, true);
    setCartDrawerError('');

    try {
      await mutationFn();
      const latestCart = await fetchCart();
      syncVisibleSummary(latestCart);
      await renderSections();
    } catch (error) {
      if (error && error.status === 429) {
        setCartDrawerError(TOO_MANY_REQUESTS_MESSAGE);
      }
      const latestCart = await fetchCart().catch(function () {
        return null;
      });
      if (latestCart) syncVisibleSummary(latestCart);
      await renderSections().catch(function () {});
    } finally {
      addonRequestInFlight = false;
      setLoading(node, false);
    }
  }

  function initAddon(node) {
    if (!node || node.dataset.ready === 'true') return;
    node.dataset.ready = 'true';

    const toggle = node.querySelector('[data-cart-addon-toggle]');
    if (!toggle) return;

    const variantId = Number(node.dataset.variantId || 0);
    const defaultEnabled = node.dataset.defaultEnabled === 'true';
    const storageKey = node.dataset.storageKey || '';

    async function ensureDefaultState() {
      if (!defaultEnabled || !variantId || addonRequestInFlight) return false;

      const dismissed = storageKey ? addonDismissedKeys.has(storageKey) : false;
      if (dismissed) return false;

      toggle.checked = true;

      const cart = await fetchCart();
      const addonItem = findAddonItem(cart, variantId);
      syncAddonNode(node, cart);

      if (addonItem) {
        return true;
      }

      toggle.checked = true;

      await runCartMutation(node, async function () {
        await addVariant(variantId);
        if (storageKey) addonDismissedKeys.delete(storageKey);
      });

      return true;
    }

    if (defaultEnabled) {
      toggle.checked = true;
    }

    toggle.addEventListener('change', async function (event) {
      if (addonRequestInFlight) return;

      event.stopPropagation();

      const intendedChecked = toggle.checked;

      await runCartMutation(node, async function () {
        const cart = await fetchCart();
        const addonItem = findAddonItem(cart, variantId);

        if (intendedChecked) {
          if (!addonItem) {
            await addVariant(variantId);
            if (storageKey) addonDismissedKeys.delete(storageKey);
          }
        } else if (addonItem) {
          await removeLineItem(addonItem.key);
          if (storageKey) addonDismissedKeys.add(storageKey);
        }
      });
    });

    ensureDefaultState()
      .then(function (handledDefault) {
        if (handledDefault) return null;
        return fetchCart().then(function (cart) {
          syncAddonNode(node, cart);
        });
      })
      .catch(function () {})
      .finally(function () {
        setLoading(node, false);
      });
  }

  function initAll() {
    cleanupAddonLineItems();
    document.querySelectorAll('[data-cart-addon]').forEach(initAddon);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  const observer = new MutationObserver(function () {
    initAll();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
